const envUrl = (process.env.REACT_APP_BACKEND_URL || "").replace(/\/$/, "");
const isLocalhost =
  typeof window !== "undefined" &&
  ["localhost", "127.0.0.1"].includes(window.location.hostname);

export const API_BASE = isLocalhost && envUrl ? envUrl : window.location.origin;
export const API = `${API_BASE}/api`;
